import { AxiosError } from 'axios';
import { onMounted, ref } from 'vue';

export function useFetch<T>(
  fetchFunction: () => Promise<T>,
  onError?: (error: AxiosError) => void,
  autoFetch = true,
) {
  const data = ref<T>();
  const isLoading = ref(false);

  async function fetchData() {
    try {
      data.value = await fetchFunction();
      isLoading.value = false;
    } catch (err) {
      if (err instanceof AxiosError && onError) {
        onError(err);
      } else throw err;
    } finally {
      isLoading.value = false;
    }
  }

  onMounted(() => {
    if (autoFetch) {
      fetchData();
    }
  });

  return {
    data,
    fetchData,
    isLoading,
  };
}
